module.exports = __webpack_public_path__ + "img/pic_number_60.a24eab28.png";